function ProductPageCartAdd() {
	this.form = null;
	this.btn = null;
}

ProductPageCartAdd.prototype.yytBeforeAddToCart = new YytBeforeAddToCart();
ProductPageCartAdd.prototype.yytAfterAddToCart = new YytAfterAddToCart();

ProductPageCartAdd.prototype.setFrom = function (form) {
	if (!form) return console.error("form が存在しません");
	this.form = form;
};

ProductPageCartAdd.prototype.setBtn = function (btn) {
	if (!btn) return console.error("btn が存在しません");
	this.btn = btn;
};

// カートに商品を追加する前に実行する処理
ProductPageCartAdd.prototype.beforeProcess = function () {
	this.yytBeforeAddToCart.animationStart(this.btn);
	this.yytBeforeAddToCart.isFormDisabled(this.form);
	this.yytBeforeAddToCart.isBtnDisabled(this.btn);
};

// カートに商品を追加した後に実行する処理
ProductPageCartAdd.prototype.successAfterProcess = async function () {
	this.yytAfterAddToCart.animationEnd(this.btn);
	await this.yytAfterAddToCart.cartCountChange();
	this.yytAfterAddToCart.isFormEnabled(this.form);
	this.yytAfterAddToCart.isBtnEnabled(this.btn);
};

/**
 * エラーが発生した後に実行する処理
 */
ProductPageCartAdd.prototype.errorAfterProcess = function () {
	this.yytAfterAddToCart.errorAnimationEnd(this.btn);
	this.yytAfterAddToCart.isFormEnabled(this.form);
	this.yytAfterAddToCart.isBtnEnabled(this.btn);
};

ProductPageCartAdd.prototype.init = async function () {
	const _this = this;
	this.btn.addEventListener("click", async (e) => {
		e.preventDefault(); // フォームの処理を止める

		const formData = new FormData(_this.form);
		const id = formData.get("id");
		if (id === null || id === "" || id === undefined) return console.error("id が存在しません");

		try {
			_this.beforeProcess();

			const response = await ProductCartAddAPI(formData);
			if (response.status !== 200) throw new Error(response.message);

			await _this.successAfterProcess();
		} catch (error) {
			console.error("エラーが発生しました", error);
			_this.errorAfterProcess();
		}
	});
	console.log("productPageCartAdd.js");
};

// -----------------------------------------------------
// カートに商品を追加した後に実行する処理
// -----------------------------------------------------
const productPageCartAdd = new ProductPageCartAdd();
const form = document.querySelector("[action='/cart/add']");
const btn = document.querySelector("#js-cartAddBtn");
productPageCartAdd.setFrom(form);
productPageCartAdd.setBtn(btn);
if (form && btn) productPageCartAdd.init();
